import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { selectLogout, useAuthStore } from '@/stores/auth.store';
import { IconRefresh } from '@tabler/icons-react';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { AxiosError } from 'axios';
import { toast } from 'sonner';

interface GeneralErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  minimal?: boolean;
  error?: any;
  reset: () => void;
}

export default function GeneralError({
  className,
  minimal = false,
  error,
  reset,
}: GeneralErrorProps) {
  const navigate = useNavigate();
  const { history } = useRouter();
  const logout = useAuthStore(selectLogout);

  if (error instanceof AxiosError) {
    if (error.response?.status === 401) {
      toast.error('Sua sessão expirou, por favor, faça login novamente.');
      logout();
      navigate({ to: '/sign-in' });
    }
  }

  return (
    <div className={cn('h-svh w-full', className)}>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
        {!minimal && (
          <h1 className='text-[7rem] font-bold leading-tight'>Oops! 😥</h1>
        )}
        <span className='font-medium'>Algo inesperado aconteceu {`:')`}</span>
        <p className='text-center text-muted-foreground'>
          Por favor, tente novamente mais tarde.
        </p>
        {!minimal && (
          <div className='mt-6 flex gap-4'>
            <Button
              variant='outline'
              onClick={() => navigate({ to: '/' })}
            >
              Voltar para a página inicial
            </Button>
            <Button onClick={reset}>
              Tentar novamente
              <IconRefresh className='ml-2 h-4 w-4' />
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
